export enum Entities {
	SUPPLEMENTS = 'supplements',
	PLANS_PERSONALIZED = 'plans_personalized',
	CLOTHES = 'clothes',
	ACCESSORIES = 'accessories',
	ALL = 'all'
}
